import { Navigate, useLocation } from "react-router-dom";
import { homeForRole, useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/portal/ui";

export default function RequireRole({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F6F4FA]" data-testid="auth-loading">
        <Spinner />
      </div>
    );
  }
  if (!user) return <Navigate to="/area-riservata" state={{ from: location.pathname }} replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeForRole(user.role)} replace />;
  return children;
}
